import classNames from 'classnames';
import { useState } from 'react';

import ToggleButton from 'components/common/ToggleButton';
import Apple from 'components/icons/illustrative/Apple';
import Beans from 'components/icons/illustrative/Beans';
import Dumbbell from 'components/icons/illustrative/Dumbbell';
import LowCarb from 'components/icons/illustrative/LowCarb';
import Scale from 'components/icons/illustrative/Scale';
import CloseX from 'components/icons/navigation/CloseX';
import {
  HIGH_PROTEIN,
  CALORIE_CONSCIOUS,
  FIBER_RICH,
  GLP_BALANCED_FRIENDLY,
  CARB_CONSCIOUS,
} from 'lib/constants';

const IconMap = {
  [HIGH_PROTEIN]: Dumbbell,
  [CALORIE_CONSCIOUS]: Apple,
  [FIBER_RICH]: Beans,
  [GLP_BALANCED_FRIENDLY]: Scale,
  [CARB_CONSCIOUS]: LowCarb,
};

const PickMealsFilters = ({ handleFilterChange, displayableFilters }) => {
  const [activeFilter, setActiveFilter] = useState(null);

  const clearFilter = () => {
    setActiveFilter(null);
    handleFilterChange(null);
  };

  const applyFilter = filter => {
    setActiveFilter(filter);
    handleFilterChange(filter);
  };

  const handleFilterClick = filter => {
    if (activeFilter === filter) {
      clearFilter();
    } else {
      applyFilter(filter);
    }
  };

  const renderIcon = filter => {
    const IconComponent = IconMap[filter];
    return (
      IconComponent && (
        <IconComponent
          className="icon iconMd dietary-tag mb-0.5 inline-block"
          tempoSelected={true}
        />
      )
    );
  };

  const RenderActiveFilter = () => {
    return (
      <div
        className="flex w-full border-solid border-charcoal-50 bg-tempo-gray-40 px-6 pb-2"
        id="filterSelected"
      >
        <div className="traits flex pt-2">
          <button
            className="active btn btnSm btnOutlined tempo mr-2 flex h-10 items-center rounded-full border-none text-charcoal-100 filter"
            onClick={clearFilter}
          >
            {renderIcon(activeFilter)}
            <span>{activeFilter}</span>
          </button>
          <button
            className="textMd text-primary linkTextPrimary flex items-center leading-6"
            onClick={clearFilter}
          >
            <CloseX className="icon iconMd mb-0.5" />
            <span className="pl-1">Clear Filter</span>
          </button>
        </div>
      </div>
    );
  };

  const RenderFilters = () => (
    <div
      className="traits relative flex w-full justify-start overflow-x-auto whitespace-nowrap border-b border-solid border-b-charcoal-60 px-4 pb-3 bp2:border-b-0 bp2:px-6"
      id="filters"
    >
      {displayableFilters &&
        displayableFilters.map((filter, index) => (
          <ToggleButton
            key={filter}
            className={classNames(
              'btn btnSm textSm btnOutlined flex h-10 items-center whitespace-nowrap rounded-full border-none text-charcoal-100 filter hover:bg-charcoal-60',
              {
                'ml-1': index !== 0,
                'bg-charcoal-50': activeFilter !== filter,
                'bg-primary text-white': activeFilter === filter,
              }
            )}
            handleClick={() => handleFilterClick(filter)}
            selected={activeFilter === filter}
            type="menuFilter"
          >
            {renderIcon(filter)}
            <span className="ml-1">{filter}</span>
          </ToggleButton>
        ))}
    </div>
  );

  return activeFilter ? <RenderActiveFilter /> : <RenderFilters />;
};

PickMealsFilters.propTypes = {
  handleFilterChange: PropTypes.func.isRequired,
  displayableFilters: PropTypes.array.isRequired,
};

export default PickMealsFilters;
